import { PreSigninStepsEnum } from "enum/common";

export const PreSigninSteps = [
  PreSigninStepsEnum.DETAIL,
  PreSigninStepsEnum.PreRegister,
];
